import { getPasswordStrength } from '../lib/formValidation'

interface PasswordStrengthIndicatorProps {
  password: string
}

export default function PasswordStrengthIndicator({ password }: PasswordStrengthIndicatorProps) {
  if (!password) return null

  const { score, label, color } = getPasswordStrength(password)
  
  const getStrengthBars = () => {
    const bars = []
    for (let i = 0; i < 5; i++) {
      const isActive = i < score
      bars.push(
        <div
          key={i}
          className={`h-1 w-full rounded ${
            isActive 
              ? score <= 2 
                ? 'bg-red-500' 
                : score <= 3 
                ? 'bg-yellow-500' 
                : score <= 4 
                ? 'bg-blue-500' 
                : 'bg-green-500'
              : 'bg-gray-200'
          }`}
        />
      )
    }
    return bars
  }

  return (
    <div className="space-y-2">
      <div className="flex space-x-1">
        {getStrengthBars()}
      </div>
      <div className="flex justify-between items-center text-xs">
        <span className="text-gray-600">Password strength:</span>
        <span className={`font-medium ${color}`}>{label}</span>
      </div>
    </div>
  )
}
